export default {"src":"/_next/static/media/shield_icon.18e97a41.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};